import React from "react";
import { Dispatcher } from "../../flux";
import { Button } from "@vitalsource/vstui";
import Survey from "./survey";
import LabsItem from "./labs-item";

class LabsContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      labInfo: {}
    };

    this._getLabs = this._getLabs.bind(this);
    this._renderLabStudents = this._renderLabStudents.bind(this);
    this._learnMoreHandler = this._learnMoreHandler.bind(this);
    this.backToLabs = this.backToLabs.bind(this);
    this._closeLabsPanel = this._closeLabsPanel.bind(this);
  }

  UNSAFE_componentWillMount() {
    Fraction.Helpers.Users.saveUserData("labNotificationsUpdated", Date.now());
    Dispatcher.emit(Dispatcher.PANEL_CHANGE);
  }

  componentDidMount() {
    Jigsaw.Labs.getAll(
      function (response) {
        if (response.isSuccess()) {
          var labInfo = {};
          for (var i = 0; i < response.data.length; i++) {
            var lab = response.data[i];
            labInfo[lab.name] = lab;
          }
          this.setState({ labInfo: labInfo });
        }
      }.bind(this)
    );
  }

  _closeLabsPanel() {
    Dispatcher.emit(Dispatcher.TOGGLE_PANEL, "labs");
  }

  _getLabs() {
    if (!this.labs) {
      this.labs = { labStudents: [], deprecated: [] };
      // yeah... we need to pull this in late because they're not loaded when labs is..
      // luckily we don't actually need to do anything here other than read the metadata.
      const gadgets = require("../../gadgets");
      gadgets.map(gadget => {
        const metadata = gadget.metadata();
        let lab = {
          id: metadata.id,
          name: metadata.name,
          description: metadata.description,
          launch: metadata.launch
            ? () => {
                this.setState({ launch: metadata.id });
              }
            : false,
          learnMore: metadata.learnMore
            ? () => {
                metadata.learnMore(this.props.isbn);
              }
            : false,
          toggle: metadata.toggle
            ? () => {
                metadata.toggle(this.props.isbn);
              }
            : false,
          star: metadata.starLab
        };
        if (metadata.lab) {
          switch (metadata.lab) {
            case "deprecated":
              this.labs.deprecated.push(lab);
              break;
            case "student":
              this.labs.labStudents.push(lab);
              break;
            default:
              break;
          }
        }
      });
    }
    return this.labs;
  }

  _renderLabStudents(labItems, category) {
    const labItemComponents = labItems.map((lab, index) => (
      <LabsItem
        isbn={this.props.isbn}
        lab={lab}
        key={lab.id}
        index={index}
        category={category}
      />
    ));
    return (
      <div className="lab-category">
        <div className="labs-list">{labItemComponents}</div>
      </div>
    );
  }

  _learnMoreHandler() {
    this.props.learnMoreTour();
  }

  backToLabs() {
    this.setState({ launch: false });
  }

  render() {
    if (this.state.launch) {
      const gadgets = require("../../gadgets");
      const Lab = gadgets.find(
        gadget => gadget.metadata().id === this.state.launch
      ).class;
      return <Lab isbn={this.props.isbn} backToLabs={this.backToLabs} />;
    } else if (this.state.labInfo) {
      const { labStudents, deprecated } = this._getLabs();
      return (
        <div id="labs-container">
          <div className="header noselect">
            <h2
              id="panel-header-labs"
              className={
                "panel-title no-highlight " +
                (typeof this.props.title === "object" ? "has-content" : "")
              }
              tabIndex={-1}
            >
              {i18n.t("reader.panels.labs") || this.props.title}
            </h2>
            <Button
              className="panel-close-button"
              onClick={this._closeLabsPanel}
              naked
            >
              <span>
                {i18n.t("reader.panels.close-panel", {
                  panelName: i18n.t("reader.panels.labs")
                })}
              </span>
            </Button>
          </div>
          <Survey />
          {this._renderLabStudents(labStudents, "lab-students")}
          {this._renderLabStudents(deprecated, "deprecated")}
        </div>
      );
    } else {
      return <span />;
    }
  }
}

function newLabNotifications() {
  const newLabs = [
    {
      lab: "emoji-reactions",
      updated: Date.now()
    }
  ];
  const lastSeen =
    Fraction.Helpers.Users.getUserData("labNotificationsUpdated") || 0;
  const unseenLabs = newLabs.filter(lab => lab.updated > lastSeen);
  return unseenLabs.length;
}

const gadgetId = "labs";
module.exports = {
  class: LabsContainer,
  metadata: () => {
    return {
      id: gadgetId,
      name: i18n.t(`reader.panels.${gadgetId}`),
      notificationCount: newLabNotifications,
      learnMore: false,
      launch: "// TODO",
      toggle: false,
      expanded: false,
      type: "panel",
      hideHeader: true,
      enabled: () => Fraction.Brand.Labs.enabled,
      hideInMobile: true,
      sidebar: {
        icon: "/img/labs/labs.svg",
        toolTip: () => {
          if (newLabNotifications() > 0) {
            return `<div class="block-tooltip"><h4 class="tooltip-title">${i18n.t(
              "emoji-reactions.title"
            )}</h4><p>${i18n.t("emoji-reactions.description")}</p></div>`;
          } else {
            return i18n.t(`reader.panels.${gadgetId}`);
          }
        },
        action: () => {
          Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId);
        }
      }
    };
  }
};
